import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer' // Optional
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './api/config.js'
import i18n from './i18n'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import MDialog from 'vue-m-dialog'
import 'vue-m-dialog/dist/index.css'
import VueCropper from 'vue-cropper'

Vue.config.productionTip = false

Vue.prototype.$http = axios

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(MDialog, {
  alertOptions: {
    title: '提示'
  }, // alert全部默认配置
  confirmOptions: {
    title: '请确认'
  } // confirm 全局默认配置
})
Vue.use(VueCropper)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

i18n.locale = 'zh_CN'
